import { render, staticRenderFns } from "./FooterSide.vue?vue&type=template&id=fd8ccf30"
import script from "./FooterSide.vue?vue&type=script&lang=js"
export * from "./FooterSide.vue?vue&type=script&lang=js"
import style0 from "./FooterSide.vue?vue&type=style&index=0&id=fd8ccf30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports